import { uniq } from "lodash";

export const arrayRemoveElementsByIndex = <T>(arr: Array<T>, indexesToRemove: Array<number>): Array<T> => {
	const toRemoveSet = new Set(indexesToRemove);
	return arr.filter((_, i) => !toRemoveSet.has(i));
};

export const arrayHasDuplicates = <T>(arr: Array<T>): boolean => uniq(arr).length !== arr.length;
